enum AuctionStatuses {
  NONE = "None",
  PREPARED = "Prepared",
  ACTIVE = "Active",
  LIVE = "Live",
  ENDED = "Ended"
}

export default AuctionStatuses;
